import React,{useState} from 'react';
import { AboutUsData } from "../../constants/index";
import { useStateContext } from '../../context/ContextProvider';

import {AboutUsImage1,AboutUsImage2,AboutUsImage3,AboutBg,AboutBg_dark}from "../../assets/images/AboutUsImages"
import { BackgroundGradient } from '../ui/Backgroundgradient';
const AboutUsHero = () => {
  const { currentLang,currentMode } = useStateContext();

  const bgImage = currentMode === 'Dark' ? AboutBg_dark : AboutBg;
  
  

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className={`pt-24 pd:mt-32 lg:pt-36 w-full`}
    style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="container pb-12">
        <div className="flex flex-col mb-10 lg:flex-row items-center justify-between gap-8 md:gap-10 lg:gap-12">
          <div className="flex-1 space-y-8 md:space-y-10 md:max-w-[50%]">
            <div className="space-y-4">
              <h2 className="h3 animated-gradient-text">
                {currentLang === "ar" ? AboutUsData.Main_title_Ar : AboutUsData.Main_title_En}
              </h2>
              <p className="body-1 text-light-text dark:text-dark-text leading-relaxed">
                {currentLang === "ar" ? AboutUsData.Main_description_Ar : AboutUsData.Main_description_En}
              </p>
            </div>
          </div>

          <div 
            className="flex-shrink-0 mt-8 lg:mt-0"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div dir='rtl'    className="flex items-center  flex-row relative">
            <div   className={`relative bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2 
             p-2 md:w-[180px] w-[120px] h-[170px] md:h-[250px] rounded-lg shadow-lg border border-light-glassStrock2 backdrop-blur-lg dark:border-dark-glassStrock1 z-10 transition-all duration-500 ease-in-out ${
                 isHovered 
                 ? 'transform md:ml-2 ml-1 rotate-0' 
                 : 'transform md:-ml-4 -ml-2 rotate-12 translate-y-4'
                }`}>
              <img 
                src={AboutUsImage2} 
                alt="About Us" 
                className=' rounded-lg w-full h-full object-cover  '
              />
              </div>
            <div className="relative bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2
              p-2 md:w-[200px] md:h-[300px] w-[135px] h-[200px]  rounded-lg shadow-lg border border-light-glassStrock2 backdrop-blur-lg dark:border-dark-glassStrock1 z-10">
            <img 
                src={AboutUsImage1} 
                alt="About Us" 
                className=' rounded-lg w-full h-full object-cover  '
              />
  
              
            </div>
            
        
              <div   className={`relative bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2
                p-2 md:w-[180px] w-[120px] h-[170px] md:h-[250px] rounded-lg shadow-lg border border-light-glassStrock2 backdrop-blur-lg dark:border-dark-glassStrock1  transition-all duration-500 ease-in-out ${
                  isHovered 
                    ? 'transform md:mr-2 mr-1 rotate-0' 
                    : 'transform md:-mr-4 -mr-2 -rotate-12 translate-y-4'
                }`}>
                      <img 
                src={AboutUsImage3} 
                alt="About Us" 
             className=' rounded-lg w-full h-full object-cover  '
              />
                </div>
            
            </div>
          </div>
        </div>
        <WCard />
      </div>
    </div>
  );
};

 
export function WCard() {
    const { currentLang } = useStateContext();
    const isRTL = currentLang === "ar";
  return (
    <div className="mt-4 md:mt-6 lg:mt-10 flex flex-wrap md:flex-nowrap gap-3 md:gap-5 xl:gap-7">
      <BackgroundGradient 
             
             className="rounded-[22px] w-full flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10 lg:gap-12 p-4 sm:p-10 bg-light-secondary dark:bg-dark-secondary"
         >
      <div
        className={` rounded-xl bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2
  `}
      >
    
        <h3 className="h4  mb-3 text-light-blue dark:text-dark-title">
                {currentLang === "ar" ? AboutUsData.Third_title_Ar : AboutUsData.Third_title_En}
              </h3>
              <p className="body-1 text-light-subtitle dark:text-dark-subtitle">
                {currentLang === "ar" ? AboutUsData.Third_description_Ar : AboutUsData.Third_description_En}
              </p>

      
      </div>
      </BackgroundGradient>
      <BackgroundGradient 
             
             className="rounded-[22px] w-full flex flex-col lg:flex-row items-center justify-between gap-8 md:gap-10 lg:gap-12 p-4 sm:p-10 "
         >
      <div
        className={` rounded-xl 
  `}
      >
      <h3 className=" h4 mb-3 text-light-secondary">
                {currentLang === "ar" ? AboutUsData.Second_title_Ar : AboutUsData.Second_title_En}
              </h3>
              <p className="body-1 text-light-primary">
                {currentLang === "ar" ? AboutUsData.second_description_Ar : AboutUsData.second_description_En}
              </p>
      </div>
  </BackgroundGradient>
    </div>
  );
}






export default AboutUsHero;